// A track's icon tile, with its level number on the corner for multi-level
// tracks. It sits on the card face (AchievementCardFace), reading its level
// palette (`--lvl-*`); the number's ring matches the face, so it reads as a
// cut-out. A complete track turns neutral, like its face.

import React from 'react';
import { cn } from '@/utilities/cn';
import type { AchievementIcon } from '@airhead-games/shared/types';
import { ACHIEVEMENT_ICON_COMPONENTS } from './achievementIcons';

type AchievementMedalProps = {
  icon: AchievementIcon;
  level: number | null; // null = a one-time track, which shows no number
  complete?: boolean;
};

const AchievementMedal: React.FC<AchievementMedalProps> = ({
  icon,
  level,
  complete = false,
}) => {
  const Icon = ACHIEVEMENT_ICON_COMPONENTS[icon];
  return (
    <div className="relative">
      <div
        className={cn(
          'flex size-16 items-center justify-center rounded-2xl',
          complete
            ? 'bg-muted-foreground text-card'
            : 'bg-(--lvl-500) text-(--lvl-950)'
        )}
      >
        <Icon className="size-8" />
      </div>
      {level !== null && (
        <span
          className={cn(
            'absolute -right-2 -bottom-2 flex size-7 items-center justify-center rounded-full text-sm font-bold ring-3',
            complete
              ? 'bg-muted text-muted-foreground ring-muted'
              : 'bg-(--lvl-50) text-(--lvl-500) ring-(--lvl-50) dark:bg-(--lvl-950) dark:ring-(--lvl-950)'
          )}
        >
          {level}
        </span>
      )}
    </div>
  );
};

export default AchievementMedal;
